export const THREE_CARD_AMOUNT_OF_HANDS = 5
